<template>
  <div class="main-wrap">
    <!-- 金额总览区域 start -->
    <div class="header-info">
      <!-- 水印 -->
      <div class="watermark">{{ $route.params.team }}</div>
      <div class="title-primary">
        <div class="table">总租赁金额</div>
        <div class="money">￥{{ leaseData.thismouthtotal }}</div>
      </div>
      <van-row class="title-secondary" type="flex" justify="space-between">
        <div>
          <div class="money">￥{{ leaseData.thismounthsubsist }}</div>
          <div class="table">本月应收账款总额</div>
          <br />
          <div class="money">￥{{ leaseData.thismonthamout }}</div>
          <div class="table">本月毛利润</div>
        </div>
        <div>
          <div class="money">￥{{ leaseData.totalsubsist }}</div>
          <div class="table">总应收账款</div>
          <br />
          <div class="money">￥{{ leaseData.todayamout }}</div>
          <div class="table">今日租赁总额</div>
        </div>
      </van-row>

      <!-- <van-row class="echart-wrpa">
        <van-row class="echart-container" :style="{ height: showEchart ? '420px' : '0' }">
          <div class="echart" id="echart01" ref="echart01"></div>
          <div class="echart" id="echart02" ref="echart02"></div>
        </van-row>
        <van-row class="fold" type="flex" justify="center" @click="showEchart = !showEchart">
          <van-icon :class="showEchart ? 'active' : ''" name="arrow-down" />
        </van-row>
      </van-row> -->
    </div>
    <!-- 金额总览区域 end -->

    <!-- 卡片区域 start -->
    <DataReportTableCard :box="box"></DataReportTableCard>
    <!-- 卡片区域 end -->

    <!-- 列表区域 start -->
    <div class="footer-list">
      <van-list
        class="container list"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        finished-text="没有更多了"
        error-text="点击重新加载"
        @load="onLoad"
      >
        <van-row
          class="list-item"
          v-for="(item, index) in dataList"
          :key="index"
          type="flex"
          justify="space-between"
          align="center"
          @click="goToInfo(item.id, item.name)"
        >
          <van-row class="left">
            <div class="abbreviation">{{ item.name }}</div>
            <div class="fullName">本月租赁额：￥{{ item.currencyamount }}</div>
          </van-row>
          <van-row class="right" type="flex">
            <div class="value">{{ item.thismouthin }}</div>
            <van-icon name="arrow" />
          </van-row>
        </van-row>
      </van-list>
    </div>
    <div class="watermark-fixed">{{ $route.params.team }}</div>
    <!-- 列表区域 end -->
  </div>
</template>

<script>
import DataReportTableCard from "../../../../components/DataReportTableCard.vue";
import echarts from "echarts";
export default {
  components: {
    DataReportTableCard,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      showEchart: false,
      page: 1,
      leaseData: {},
      dataList: [],
      box: {},
    };
  },
  methods: {
    /**
     * 初始化采购金额信息
     */
    async initMoneyInfo() {
      // 在这发起请求
      let params = {
        teamname: this.$route.params.team,
      };
      let { data } = await this.$post(this.$api.stGetLeaseTeamInfo, params);
      this.leaseData = data;
      this.box = data.box;
      // this.echartInit();
    },
    /**
     * 渲染echart
     */
    echartInit() {
      this.$nextTick(() => {
        const list1 = this.leaseData.month.lists;
        const list2 = this.leaseData.year.lists;
        const echart01 = echarts.init(this.$refs.echart01);
        const echart02 = echarts.init(this.$refs.echart02);

        echart01.setOption({
          title: {
            text: this.leaseData.month.text,
            left: "center",
            top: "0px",
            textStyle: {
              color: "#505050",
              fontSize: "14px",
            },
          },
          tooltip: { trigger: "axis" },
          color: ["#00baad", "#3c8ff7"],
          legend: {
            orient: "horizontal",
            left: "center",
            bottom: "5px",
            data: ["订单量", "采购金额(CNY)"],
          },
          grid: {
            left: "20px",
            right: "20px",
            top: "30px",
            bottom: "45px",
            containcolor_3: true,
          },
          // toolbox: { feature: { saveAsImage: {} } },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: list1.dates,
          },
          yAxis: [
            {
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
            {
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
          ],
          series: [
            {
              name: "订单量",
              type: "line",
              data: list2.num,
              yAxisIndex: 0,
              smooth: true,
            },
            {
              name: "采购金额(CNY)",
              type: "line",
              data: list1.price,
              yAxisIndex: 0,
              smooth: true,
            },
          ],
        });

        echart02.setOption({
          title: {
            text: this.leaseData.year.text,
            left: "center",
            bottom: "0px",
            textStyle: {
              color: "#505050",
              fontSize: "14px",
            },
          },
          tooltip: { trigger: "axis" },
          color: ["#2a82e4"],
          grid: {
            left: "20px",
            right: "20px",
            top: "10px",
            bottom: "45px",
            containcolor_3: true,
          },
          // toolbox: { feature: { saveAsImage: {} } },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: list2.dates,
          },
          yAxis: [
            {
              name: "采购金额",
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
          ],
          series: [
            {
              name: "采购金额(CNY)",
              type: "bar",
              data: list2.price,
              yAxisIndex: 0,
              smooth: true,
            },
          ],
        });
      });
    },
    /**
     * 列表触底时触发
     */
    async onLoad() {
      // console.log("onLoad");
      // 请求列表数据
      let params = {
        // page: this.page,
        teamname: this.$route.params.team,
      };
      try {
        let { data } = await this.$post(this.$api.stGetLeaseMemberList, params);
        // 若数据已全部加载完毕

        // 未开启分页
        // if (data.length == 0) {
        this.finished = true;
        // }
        if (this.page == 1) {
          this.dataList = [];
        }
        this.dataList.push(...data);
        this.page++;
      } catch (error) {
        console.log(error);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * 跳转到供应商详情
     */
    goToInfo(id, name) {
      this.$router.push(`/leaseReport/lease/member/${id}/${name}`);
    },
  },
  mounted() {
    this.initMoneyInfo();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: this.$route.params.team });
    });
  },
};
</script>

<style lang="scss" scoped>
$yellow: #ff8d1a;
$gary: #a6a6a6;
.main-wrap {
  min-height: 100%;
  background-color: #f6f4f2;
  .header-info {
    position: relative;
    box-sizing: border-box;
    padding: 16px;
    font-size: 12px;
    color: #fff;
    background-color: #51596e;

    .watermark {
      position: absolute;
      left: 50%;
      bottom: 0;
      font-size: 50px;
      color: rgba(255, 255, 255, 0.26);
      transform: translateX(-50%);
    }

    .title-primary {
      color: #fff;

      .money {
        text-align: center;
        font-family: "MicrosoftJhengHei";
        font-size: 30px;
        font-weight: 500;
      }
    }

    .title-secondary {
      margin-top: 30px;
      text-align: center;
      font-size: 12px;

      .money {
        margin-bottom: 6px;
        color: $yellow;
      }
    }

    .echart-wrpa {
      margin-top: 20px;
      background-color: #51596e;

      .echart-container {
        overflow: hidden;
        transition: height 0.8s;
        .echart {
          margin-bottom: 20px;
          height: 200px;
          background-color: #fff;
        }
      }

      .fold {
        padding: 8px 0;
        z-index: 1;
        background-color: #51596e;
      }
      .fold .van-icon {
        font-size: 26px;
        transition: transform 0.8s;
      }
      .fold .van-icon.active {
        transform: rotate(-180deg);
      }
    }
  }

  .footer-list {
    margin-top: 20px;
    background-color: #fff;
    .container {
      padding: 16px;
      .list-item {
        padding-top: 4px;
        padding-bottom: 8px;
        border-bottom: 1px solid #e5e5e5;

        .left {
          .abbreviation {
            color: #505050;
            font-size: 14px;
          }
          .fullName {
            color: #a6a6a6;
            font-size: 12px;
          }
        }

        .right {
          .value {
            font-size: 12px;
            color: $yellow;
          }
          .van-icon {
            margin-left: 8px;
            font-size: 16px;
          }
        }
      }
    }
  }
  .watermark-fixed {
    position: fixed;
    bottom: 50px;
    left: 50%;
    font-size: 80px;
    color: rgba(103, 117, 136, 0.22);
    transform: translateX(-50%);
  }
}
</style>
